import { frameTop } from './frame-top';
import { bufferAroundPlace } from './buffer-around-place';
import type { AnyTool, Tool } from '../tools/types';

export const MACROS: AnyTool[] = [frameTop, bufferAroundPlace] as Tool<unknown, unknown>[];
